import * as v from "valibot";

// request
export const RequestSchema = v.object({
  ClusterId: v.string(),
  RequestId: v.nullish(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const StepSchema = v.object({
  endTime: v.nullish(v.string()),
  startTime: v.nullish(v.string()),
  status: v.string(),
  step: v.string(),
});
export type Step = v.InferOutput<typeof StepSchema>;

export const DataClassSchema = v.object({
  progress: v.number(),
  status: v.string(),
  steps: v.array(StepSchema),
});
export type DataClass = v.InferOutput<typeof DataClassSchema>;

export const DataSchema = v.object({
  code: v.nullish(v.number()),
  data: DataClassSchema,
  message: v.nullish(v.string()),
  requestId: v.nullish(v.string()),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: v.nullish(DataSchema),
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
